import LocalSettings from "nexia_mobile/models/local_settings";
import Platform from "nexia_mobile/platform";
import { en_us as English, en_us_values as englishValues } from "./en_us_core";
import {
  fr_ca as French,
  fr_ca_values as frenchCanadianValues,
} from "./fr_ca_core";
import { es_mx as Spanish, es_mx_values as spanishValues } from "./es_mx_core";
import stringsProvider from "./stringsProvider";

// Used when showing and setting the value in languageDialog
export const localeValues = [
  { ...englishValues },
  { ...frenchCanadianValues },
  { ...spanishValues },
];

// Returns the current set of language strings
// demandedLocale is usually after a language selection by the user
export function getLanguageSet(demandedLocaleString = null) {
  const referenceLocale = getLanguageLocale(demandedLocaleString);
  return stringsProvider(referenceLocale);
}

// Returns the current locale of language
// demandedLocale is usually after a language selection by the user
export function getLanguageLocale(demandedLocaleString = null) {
  const referenceLocaleString =
    demandedLocaleString || LocalSettings.getLocale() || "en_us";
  let phoneLocale = Platform.getAppInfo().currentLocale;
  phoneLocale = phoneLocale
    ? phoneLocale.toLowerCase().replace("-", "_")
    : "en_us";

  // Auto is part of the locale string. Normal: en_us, Auto: auto|en_us
  // This is to avoid needing a separate database column just for auto.
  const localeVars = referenceLocaleString.split("|");
  let storedLocale = localeVars.length > 1 ? localeVars[1] : localeVars[0];
  const isAuto = localeVars.length > 1;

  return isAuto ? phoneLocale : storedLocale;
}

export const template = (string, templates) => {
  let newString = string;
  const keys = Object.keys(templates);
  keys.forEach((key) => {
    const regex = new RegExp(`#{${key.toUpperCase()}}#`, "g");
    newString = newString.replace(regex, templates[key]);
  });
  return newString;
};

export function occupiedHelper(string) {
  const occupancyLanguages = [
    English[201].toLowerCase(),
    French[201].toLowerCase(),
    Spanish[201].toLowerCase(),
    "occupied", // For testing while strings are prefixed with E_ or FR_
  ];
  return occupancyLanguages.indexOf(string.toLowerCase());
}



// WEBPACK FOOTER //
// ../nx-components/src/Locales/index.js